module.exports = __webpack_public_path__ + "img/chinesecompany42.a1da4392.png";